const state = {
  pwLoading: true
}

function initialState() {
  return {
    pwLoading: true
  }
}

// getters
const getters = {

}

// actions
const actions = {

  setPWloading({
    commit,
    state
  }, status) {
    commit('updatePWLoading', status)
  },
  resetToInitialState({
    commit,
    state
  }) {
    commit('reset')
  }

}

// mutations
const mutations = {

  updatePWLoading(state, status) {
    state.pwLoading = status
  },
  reset(state) {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
